import { Label } from "@patient-watch/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@patient-watch/ui/select";

import {
    type FormBuilderData,
    type StandardFormCalculator,
    useSetStandardFormCalculator,
} from "@/features/forms/api/formBuilderApi";

export function FormCalculatorSelect({ form }: { form: FormBuilderData }) {
    const mutation = useSetStandardFormCalculator(form.form_id);
    const config =
        form.score_engine_config &&
        typeof form.score_engine_config === "object" &&
        !Array.isArray(form.score_engine_config)
            ? form.score_engine_config
            : {};
    const managed = config.managed_by === "form-builder";
    const custom = !managed && (form.score_engine != null || Object.keys(config).length > 0);
    const value: StandardFormCalculator | "custom" = custom
        ? "custom"
        : form.score_engine === "sum_total"
          ? "total"
          : "none";
    const hasNumericSource = form.pages.some((page) =>
        page.inputs.some((input) => ["scale-rating", "number", "slider"].includes(input.input_key))
    );

    return (
        <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">Calculator</Label>
            <Select
                value={value}
                onValueChange={(next) => mutation.mutate(next as StandardFormCalculator)}
                disabled={mutation.isPending || custom}
            >
                <SelectTrigger aria-label="Calculator" className="h-8 text-sm">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {custom ? <SelectItem value="custom">Custom</SelectItem> : null}
                    <SelectItem value="none">None</SelectItem>
                    <SelectItem value="total" disabled={!hasNumericSource}>
                        Total
                    </SelectItem>
                </SelectContent>
            </Select>
            <p className="text-2xs text-muted-foreground">
                {custom
                    ? "This form uses a bespoke calculator and cannot be changed here."
                    : hasNumericSource
                      ? "Total adds all scale, number, and slider answers."
                      : "Add a scale, number, or slider question to use Total."}
            </p>
        </div>
    );
}
